import VirtuozzoImage from "public/iaas/kubernetes.png";

export const IMPLEMENTATION_CONSTANTS = {
  image: VirtuozzoImage,
  title: "Implementing Virtuozzo PaaS",
  desc: "To deploy Virtuozzo PaaS, follow these steps:",
  steps: [
    {
      label: "Enable PaaS Functionality",
      text: "Activate the PaaS feature within the Virtuozzo Hybrid Cloud portal.",
    },
    {
      label: "Access the PaaS Dashboard",
      text: "Log in to the PaaS dashboard to manage applications and resources.",
    },
    {
      label: "Deploy Applications",
      text: "Use the dashboard or integrated tools to deploy applications using Docker, GIT, SVN, or archives.",
    },
    {
      label: "Configure Scaling and Monitoring",
      text: "Set up automatic scaling rules and monitor application performance through the provided tools.",
    },
    {
      label: "Utilize the Marketplace",
      text: "Explore and deploy pre-packaged applications and services as needed.",
    },
  ],
};
